import { GoCoderZIsotope } from "./_class-gocoderz-isotope";

function WebinarsIsotope() {
	$( "label" ).on( "mousedown", function () {
		let input = $( this ).closest( "div" ).find( "input:radio" );
		$( input ).trigger( "click" );
	} );

	new GoCoderZIsotope( ".js-isotope", {
		itemSelector: ".js-isotope-element",
		wrapper: ".js-isotope-wrapper",
        loadMoreAction: "load_more_webinars_ajax",
		sort: {
			getSortData: {
				date: ".js-isotope-sort-date parseInt"
			},
			sortBy: "date",
			sortAscending: false
		}
	} );
}

export { WebinarsIsotope };